import { ISessionManager } from './ISessionManager';

export class SessionManager implements ISessionManager {
  _config: any = {};
  _initialized = false;

  constructor(public config: any = {}) {
    this._config = {
      ...config
    };
  }

  public async initialize(): Promise<void> {
    this._initialized = true;
    if (this._config.sessionManager.storageOption === "local") {
      if (this._config.sessionManager.initStats) {
        sessionStorage.setItem("sessionManager", JSON.stringify(this._config.sessionManager.initStats));  
      }
      else{
        return null;
      }
    }else{
      return null;
    }
  }

  public async getSessionData(): Promise<any> {
    if (!this._initialized)
      return null;
      
    if (this._config.sessionManager.storageOption === "local") {
      let sessionData = sessionStorage.getItem("sessionManager");
      if (sessionData) {
        sessionData = JSON.parse(sessionData);
        if (sessionData["sessionStats"]) {
          const sessionStatsData = sessionData["sessionStats"];
          return sessionStatsData;
        }else{
          return null;
        }
      } else {
        return null;
      }
    }
  }

  public async saveSessionData(params: any = {}): Promise<any> {
    const {
      data = {},
    } = params

    if (!this._initialized)
      return null;

    if (this._config.sessionManager.storageOption === "local") {
      let sessionData = sessionStorage.getItem("sessionManager");
      sessionData = sessionData ? JSON.parse(sessionData) : {};
      sessionData['sessionStats'] = data;
      sessionData = JSON.stringify(sessionData);
      sessionStorage.setItem("sessionManager", sessionData);
      return data;
    }
  }
}
